// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1_H0C","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1ZlBZ"};